export const errorCodes = {
    /// <summary>
    /// Lỗi bad request
    /// </summary>
    BadRequest: 400,

    /// <summary>
    /// Lỗi không có quyền truy cập
    /// </summary>
    Unauthorized: 401,

    /// <summary>
    /// Lỗi không có quyền truy cập
    /// </summary>
    Forbidden: 403,

    /// <summary>
    /// Không tìm thấy
    /// </summary>
    NotFound: 404,

    /// <summary>
    /// Phương thức không được cho phép
    /// </summary>
    MethodNotAllowed: 405,

    /// <summary>
    /// Lỗi gặp exception
    /// </summary>
    Exception: 500,

    /// <summary>
    /// Lỗi dữ liệu đầu vào không hợp lệ
    /// </summary>
    InvalidData: 422,

    /// <summary>
    /// Lỗi trùng mã
    /// </summary>
    DuplicateCode: 423
}

export const sendStatus = {
    Confirm: 0,
    Sent: 1,
    OnDelivery: 2
}